var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrappedRestart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#030303",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6402 10.35C20.1902 8.9 18.2002 8 15.9902 8C11.5702 8 8.00024 11.58 8.00024 16C8.00024 20.42 11.5702 24 15.9902 24C19.2469 24 22.031 22.0561 23.2775 19.2665C23.555 18.6455 23.0574 18 22.3772 18C21.9356 18 21.5501 18.2831 21.3532 18.6783C20.3723 20.6474 18.3392 22 15.9902 22C12.6802 22 9.99024 19.31 9.99024 16C9.99024 12.69 12.6802 10 15.9902 10C17.6502 10 19.1302 10.69 20.2102 11.78L19.6981 12.2945C19.0703 12.9251 19.517 14 20.4068 14H22.9902C23.5425 14 23.9902 13.5523 23.9902 13V10.4142C23.9902 9.52331 22.9131 9.07714 22.2831 9.70711L21.6402 10.35Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappedRestart);
export default __webpack_public_path__ + "static/media/wrapped-restart.91b5ff3465ab01e0c45c0420a3878da4.svg";
export { ForwardRef as ReactComponent };